var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"offer-page-container"},[_c('div',{staticClass:"offers-header"},[_c('img',{attrs:{"src":`/images/triangle/triRewards_logo_${this.language}.png`}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }